import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const searchClubs = createApiThunk<Club[], ClubAndCourseSearchPayload>({
  action: 'clubs/search',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_SEARCH_CLUBS,
  getData: (payload) => payload.data,
})
